import styled from 'styled-components';

export const Hr = styled.hr`
  margin: 15px, 10px;
`;
